import toString from 'lodash.tostring';

/**
 * Returns true if the string provided is null, empty, or contains only white space characters
 * Values that are not strings are converted to a string using lodash.toString rules
 * 
 * @param {string} string - The string value to check
 * @return {boolean} True if the string is null, empty or contains white space character.  False otherwise.
 */
export function isNullOrWhiteSpace(string) {
    string = toString(string);
    return !(string?.trim());
}